import nlp from 'compromise';
import Fuse from 'fuse.js';

import type { ArticleModel } from 'api/models';
import type { RefObject } from 'react';

export function normalizeSearch(text: string): string {
    const lower = text.toLowerCase();
    const normalized = nlp(lower).numbers().toNumber().out('text');
    return normalized;
};

export function getFilteredData(
    data: ArticleModel[],
    searchValue: string,
    fuse: Fuse<ArticleModel> | null,
): ArticleModel[] {

    if (!data || searchValue.trim() === '') { return data; }

    const trimmedSearchValue = searchValue.trim().toLowerCase();

    const includesResults = data.filter(article =>
        article.articleNumber.toLowerCase().includes(trimmedSearchValue) ||
        article.displayName?.toLowerCase().includes(trimmedSearchValue)
    );

    const normalizedSearch = normalizeSearch(trimmedSearchValue);
    const fuseResults = fuse?.search(normalizedSearch).map(result => result.item) ?? [];

    const mergedSearchMap = new Map<string, ArticleModel>();
    [...fuseResults, ...includesResults].forEach(article => {
        mergedSearchMap.set(article.id, article);
    });

    return Array.from(mergedSearchMap.values());
};

export function handleArticleRowBackground(
    articleRowRef: RefObject<HTMLDivElement | null>,
    showArticleRowSelection: boolean,
){
    if (articleRowRef.current) {
        articleRowRef.current.style.backgroundColor = showArticleRowSelection ? '#e0ecf8' : 'white';
    }
};